'use client'

import { Container, Grid } from '@mui/material'

import { SanityComponent } from '@/components/SanityComponent/SanityComponent'

import type { HomePageContent } from '@/lib/queries/sanityQueryStrings'

export const HomeClient = ({ content }: { content: HomePageContent }) => (
  <Container>
    <Grid container spacing={3} mt={2} pb={2}>
      {content.map((item) => (
        <Grid item xs={12} key={item._id}>
          <SanityComponent sanityComponent={item} />
        </Grid>
      ))}
    </Grid>
  </Container>
)
